module.exports = __webpack_public_path__ + "img/audit.411e2dc5.png";